export enum OpsSettingsType {
    OpsSystem = 'ops-setting.tab.system-settings',
    UserAccount = 'ops-setting.tab.account-settings',
    DutyEngineer = 'ops-setting.tab.duty-engineers',
    ConsoleSettings = 'ops-setting.tab.console-settings',
    OutputSettings = 'ops-setting.tab.output-settings',
    Graphs = 'ops-setting.tab.graphs',
    ExtCommSettings = 'ops-setting.tab.external-comm-settings',
    SystemColor = 'ops-setting.tab.system-colors',
    EAPSettings = 'ops-setting.tab.eap-settings',
}
